import { render, staticRenderFns } from "./rpterctstdconfirmbyco.vue?vue&type=template&id=264f760b&"
import script from "./rpterctstdconfirmbyco.vue?vue&type=script&lang=js&"
export * from "./rpterctstdconfirmbyco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports